import script from "./ReportProblemForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./ReportProblemForm.vue?vue&type=script&setup=true&lang=ts"

import "./ReportProblemForm.vue?vue&type=style&index=0&id=586073ae&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-586073ae"]])

export default __exports__